import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatLegacyOption as MatOption } from '@angular/material/legacy-core';
import { ItemPickerOption } from './models/itemPickerOption';

@Component({
  selector: 'item-picker',
  templateUrl: './item-picker.component.html',
  styleUrls: ['./item-picker.component.scss'],
})
export class ItemPickerComponent implements OnInit {
  @Input() data: ItemPickerOption[] = [];

  @Output() select = new EventEmitter();

  @Output() create = new EventEmitter();

  @Input() type: string;

  @Input() placeholder: string;

  @Input() selectedValue: ItemPickerOption;

  @Input() disabled: boolean = false;
  @Input() showCreateButton: boolean = false;
  @Input() createButtonText: string = 'Create';

  search = '';
  disabledSelector = false;

  constructor() {}

  ngOnInit(): void {
    if (this.type == 'button') {
      this.disabledSelector = true;
    }
  }

  onClick(item: ItemPickerOption) {
    this.select.emit(item);
  }

  keyup() {
    let selectedItem = document.querySelector('.mat-active') as any;
    if (selectedItem) {
      selectedItem.focus();
    }
  }

  openSelector(selector) {
    this.disabledSelector = false;
    setTimeout(() => {
      selector.open();
    }, 0);
  }

  selectorClosed() {
    this.search = '';
    if (this.type == 'button') {
      this.disabledSelector = true;
    }
  }

  selectorOpened() {
    if (this.type == 'button') {
      let selectedOption = document.querySelector('.mat-selected');
      if (!selectedOption) return;
      selectedOption.classList.remove('mat-selected', 'mat-active');
    }
  }
}
